export default __webpack_public_path__ + "static/media/pencil-icon.59006286.svg";